/**
 * computeFormDeriveFingerprint
 *
 * FNV-1a 64 over a derive's canonical material — the joined `<path>=<canon>`
 * lines `computeFormDerives` builds for the operands one entry consumed.
 * Deliberately thin: line building stays in the engine, which is the only place
 * holding the evaluation overlay and therefore the only place that knows what a
 * source read actually consumed.
 *
 * The output is persisted in `FormDeriveStamp.hash`, so both the algorithm and
 * the caller's line spelling are frozen: changing either makes every stored
 * stamp read as drifted and reruns every derive on the next pass.
 */

import { fnv1a64 } from '../fnv1a64';

function computeFormDeriveFingerprint(material: string): string {
  return fnv1a64(material);
}

export { computeFormDeriveFingerprint };
